import { createSlice } from "@reduxjs/toolkit";
import { countryType, stateType } from "../types/countrystate.types";
export interface countryStateReducer {
  loading: boolean;
  stateloading:boolean;
  countries: countryType[];
  states: stateType[];
  error: Error | null;
}
const initialState: countryStateReducer = {
  loading: false,
  stateloading:false,
  countries: [],
  states: [],
  error: null,
};
export const countrystateSlice = createSlice({
  name: "countryStateSlice",
  initialState,
  reducers: {
    getCountriesApi: (state) => {
      state.loading = true;
    },
    getCountriesSuccess: (state, action) => {
      // state.states=[];
      state.countries = action.payload;
      state.loading = false;
    },
    getCountriesFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    getStatesFromApi: (state) => {
      state.states=[];
      state.stateloading = true;
    },
    getStatesSuccess: (state, action) => {
      state.states = action.payload;
      state.stateloading = false;
    },
    getStatesFailure: (state, action) => {
      state.error = action.payload;
      state.stateloading = false;
    },
    clearStateData:(state)=>{
      state.states=[]
    }
  },
});
export const {
  getCountriesApi,
  getCountriesSuccess,
  getCountriesFailure,
  getStatesFromApi,
  getStatesSuccess,
  getStatesFailure,
  clearStateData
} = countrystateSlice.actions;
export default countrystateSlice.reducer;